import React from 'react';
import { Box, Card, CardMedia, Chip, Tooltip, Typography, useTheme } from '@mui/material';
import MenuDropdown from './MenuDropdown';
import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import { useTranslation } from 'react-i18next';
import styles from './ResourceCard.styles';

const ResourceCard = ({
  resource,
  id,
  onUpdate,
  onDelete,
  origin,
  name,
  type,
  language,
  picture,
  filepath,
  withoutActions,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const themedStyles = styles(theme);

  const PLACEHOLDER_RESOURCE = `${process.env.PUBLIC_URL}/uploads/images/placeholder-resource.svg`;

  // Delete resource
  const handleDeleteResource = () => {
    onDelete(id);
  };

  // Open file
  const handleOpenResource = () => {
    window.open(filepath, '_blank');
  };

  const originChip = () => {
    const style = origin === 'program' ? themedStyles.chipProgram : themedStyles.chipCompany;
    const type = origin === 'program' ? t('resource_card_origin_program') : t('resource_card_origin_company');

    return <Chip sx={[themedStyles.chip, style]} label={type} variant="outlined" />;
  };

  return (
    <Card sx={themedStyles.container} onClick={handleOpenResource}>
      <Box sx={themedStyles.containerHeader}>
        {/* {picture ? (
          <CardMedia component="img" image={picture} sx={styles.picture} height="148" />
        ) : (
          <Box sx={styles.picturePlaceholder}>
            <CropOriginalIcon sx={styles.iconPlaceholder} />
          </Box>
        )} */}
        {
          <CardMedia
            component="img"
            image={picture ? picture : PLACEHOLDER_RESOURCE}
            sx={themedStyles.picture}
            height="148"
          />
        }
        {!withoutActions && (
          <Box sx={themedStyles.dropdownActions}>
            <MenuDropdown resource={resource} onDelete={handleDeleteResource} onUpdate={onUpdate} color={'white'} />
          </Box>
        )}
      </Box>
      <Box sx={themedStyles.content}>
        <Box sx={themedStyles.chips}>
          {type && <Chip sx={[themedStyles.chip, themedStyles.typeChip]} label={type} variant="outlined" />}
          {originChip()}
        </Box>
        <Tooltip title={name && name.length > 20 && name}>
          <Typography sx={themedStyles.name}>{name}</Typography>
        </Tooltip>
        {language && (
          <Box sx={themedStyles.containerLanguage}>
            <Box sx={themedStyles.languageBadge}>{language}</Box>
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default ResourceCard;
